import { FluxErrorCodes } from "@buildwithflux/constants";
// TODO: eslint config complains this because the folder name is `elements`, which is listed in the `boundaries/element-types` rule.
// We should probably make that very explicit since `elements` is such a common name
// eslint-disable-next-line boundaries/element-types
import { FluxBaseError } from "../flux_error/FluxBaseError";
/**
 * Throw this when trying to access an element that doesn't exist
 */
export class MissingElementDataError extends FluxBaseError {
    constructor(message, options = {}) {
        super(FluxErrorCodes.MissingElementDataError, message, options);
    }
}
//# sourceMappingURL=error.js.map